export async function registerPwa(
  onUpdate?: (worker: ServiceWorker) => void
): Promise<ServiceWorkerRegistration | undefined> {
  if (
    typeof window === "undefined" ||
    !("serviceWorker" in navigator) ||
    window.isSecureContext === false
  ) {
    return undefined;
  }

  const registration = await navigator.serviceWorker.register("/sw.js", {
    scope: "/",
    updateViaCache: "none",
  });

  const reportWaitingWorker = () => {
    if (registration.waiting) onUpdate?.(registration.waiting);
  };
  registration.addEventListener("updatefound", () => {
    const installing = registration.installing;
    installing?.addEventListener("statechange", () => {
      if (
        installing.state === "installed" &&
        navigator.serviceWorker.controller
      ) {
        reportWaitingWorker();
      }
    });
  });
  reportWaitingWorker();
  return registration;
}

export function activateWaitingWorker(worker: ServiceWorker): void {
  worker.postMessage({ type: "SKIP_WAITING" });
}
